import type { ComponentPropsWithRef, ReactElement, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface LabelProps extends ComponentPropsWithRef<'label'> {
  children?: ReactElement;
  text: ReactNode;
  htmlFor?: string;
  disabled?: boolean;
}

export const Label = ({
  children,
  text,
  className,
  disabled,
  ...props
}: LabelProps) => {
  return (
    <label
      className={twMerge(
        'flex cursor-pointer flex-col gap-0.5',
        disabled && 'cursor-default text-content-subtle',
        className
      )}
      {...props}
    >
      <span className="pl-2 text-xs">{text}</span>
      {children}
    </label>
  );
};
